import React from 'react';
import { Helmet } from 'react-helmet';

const StructuredData = () => {
  // Primary LocalBusiness Schema (Main Business)
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "HomeAndConstructionBusiness"],
    "@id": "https://teknikservisburda.com/#localbusiness",
    "name": "teknikservisburda.com",
    "alternateName": "Teknik Servis Burda - Kuşadası Söke Aydın",
    "description": "Kuşadası, Söke ve Aydın'da profesyonel kombi servisi, beyaz eşya tamiri ve klima montaj hizmeti. 15 yıllık tecrübe, aynı gün servis garantisi.",
    "url": "https://teknikservisburda.com",
    "telephone": "+905518478521",
    "email": "teknikservisburda@gmail.com",
    "logo": "https://customer-assets.emergentagent.com/job_ev-aletleri-servis/artifacts/vs6pzaqs_1.png",
    "image": [
      "https://customer-assets.emergentagent.com/job_ev-aletleri-servis/artifacts/vs6pzaqs_1.png"
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Davutlar Mah. Namık Kemal Cad. No:42B",
      "addressLocality": "Kuşadası",
      "addressRegion": "Aydın",
      "postalCode": "09400",
      "addressCountry": "TR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "37.8586",
      "longitude": "27.2597"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "Kuşadası"
      },
      {
        "@type": "City",
        "name": "Söke"
      },
      {
        "@type": "City",
        "name": "Aydın"
      },
      {
        "@type": "Place",
        "name": "Güzelçamlı"
      },
      {
        "@type": "Place",
        "name": "Davutlar"
      },
      {
        "@type": "Place",
        "name": "İncirliova"
      },
      {
        "@type": "Place",
        "name": "Germencik"
      }
    ],
    "priceRange": "₺₺",
    "currenciesAccepted": "TRY",
    "paymentAccepted": ["Nakit", "Kredi Kartı", "Havale/EFT"],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "08:00",
        "closes": "20:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Sunday"],
        "opens": "09:00",
        "closes": "18:00"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "156",
      "bestRating": "5",
      "worstRating": "1"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Teknik Servis Hizmetleri",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Buzdolabı Tamiri",
            "description": "Profesyonel buzdolabı tamir servisi. Soğutma sistemi arızaları, kompresör değişimi, termostat tamiri."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Çamaşır Makinesi Tamiri",
            "description": "Çamaşır makinesi tamir ve bakım hizmetleri. Motor arızası, pompa değişimi, elektronik kart tamiri."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Bulaşık Makinesi Tamiri",
            "description": "Bulaşık makinesi servisi. Su alma, su boşaltma, yıkama programı arızaları."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Kombi Tamiri",
            "description": "Kombi bakım ve tamir hizmeti. Kalorifer ve sıcak su problemleri, gaz kaçağı kontrolü."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Klima Tamiri",
            "description": "Klima servisi ve bakım. Gaz dolumu, kompresor tamiri, iç ve dış ünite bakımı."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Klima Montaj",
            "description": "Profesyonel klima montaj hizmeti. 9000, 12000, 18000, 24000 BTU montaj."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Termosifon Montaj",
            "description": "Termosifon montaj ve bakım servisi."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Fırın Tamiri",
            "description": "Fırın tamir hizmeti. Elektrikli ve gazlı fırın arızaları."
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "127"
    }
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://teknikservisburda.com/#organization",
    "name": "teknikservisburda.com",
    "url": "https://teknikservisburda.com",
    "logo": "https://customer-assets.emergentagent.com/job_ev-aletleri-servis/artifacts/vs6pzaqs_1.png",
    "sameAs": []
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://teknikservisburda.com/#website",
    "url": "https://teknikservisburda.com",
    "name": "teknikservisburda.com",
    "description": "Kuşadası ve Aydın'da profesyonel beyaz eşya tamiri ve teknik servis",
    "publisher": {
      "@id": "https://teknikservisburda.com/#organization"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://teknikservisburda.com/servisler?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  // FAQ Schema for Google Rich Results
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Kuşadası, Söke ve Aydın'da hangi teknik servis hizmetleri veriyorsunuz?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Kuşadası beyaz eşya servisi, Kuşadası kombi servisi, Kuşadası klima servisi, Söke kombi servisi, Aydın kombi servisi olarak hizmet veriyoruz. Buzdolabı tamiri, çamaşır makinesi servisi, bulaşık makinesi tamiri, kombi bakımı ve tamiri, klima montaj ve tamiri, termosifon montaj hizmetleri sunuyoruz."
        }
      },
      {
        "@type": "Question",
        "name": "Söke'de kombi tamircisi var mı?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Evet, Söke kombi tamircisi olarak hizmet veriyoruz. Söke ve çevresinde Vaillant, Baymak, Demirdöküm ve diğer tüm marka kombilerde profesyonel tamir ve bakım hizmeti sunuyoruz. Aynı gün servis garantisi ile hızlı çözümler sağlıyoruz."
        }
      },
      {
        "@type": "Question",
        "name": "Kombi arıza kodları nedir ve nasıl çözülür?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Kombi arıza kodları, kombinin ekranında görünen hata mesajlarıdır. E01, E02, F.28 gibi kodlar farklı arızaları gösterir. Web sitemizde Vaillant, Baymak ve Demirdöküm kombi arıza kodları rehberimizden tüm hata kodlarının anlamlarını ve çözüm önerilerini bulabilirsiniz."
        }
      },
      {
        "@type": "Question",
        "name": "Kuşadası'da aynı gün kombi servisi alabilir miyim?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Evet, Kuşadası kombi servisi olarak aynı gün servis garantisi sunuyoruz. Sabah verilen talepler için genellikle aynı gün içinde uzman teknisyenimiz adresinize ulaşır."
        }
      },
      {
        "@type": "Question",
        "name": "Hangi marka kombilere servis veriyorsunuz?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Vaillant (turboTEC, ecoTEC, atmoTEC), Baymak (Luna, Eco, Falke), Demirdöküm (Nitron, Milenyum, Atron), Buderus, ECA, Ferroli ve diğer tüm markalarda kombi servisi, bakım ve tamir hizmeti veriyoruz."
        }
      },
      {
        "@type": "Question",
        "name": "Aydın'da beyaz eşya servisi var mı?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Evet, Aydın beyaz eşya servisi olarak tüm Aydın genelinde hizmet veriyoruz. Buzdolabı, çamaşır makinesi, bulaşık makinesi tamiri için Arçelik, Beko, Bosch, Samsung, LG ve diğer tüm markalarda profesyonel servis sunuyoruz."
        }
      },
      {
        "@type": "Question",
        "name": "Klima montaj ücreti ne kadar?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Kuşadası klima servisi olarak klima montaj ücretleri BTU kapasitesine göre değişir. 9000-24000 BTU split klimalar için uygun fiyatlı montaj hizmetimiz mevcuttur. Detaylı bilgi için 0551 847 8521 numarasından bize ulaşabilirsiniz."
        }
      }
    ]
  };

  // Breadcrumb Schema
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Ana Sayfa",
        "item": "https://teknikservisburda.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Servislerimiz",
        "item": "https://teknikservisburda.com/servisler"
      }
    ]
  };

  // Service Schema - Detaylı Hizmet Bilgisi
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Teknik Servis Hizmetleri",
    "provider": {
      "@type": "LocalBusiness",
      "name": "teknikservisburda.com",
      "telephone": "+905518478521"
    },
    "areaServed": ["Kuşadası", "Söke", "Aydın", "Güzelçamlı", "Davutlar", "İncirliova", "Germencik"],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Teknik Servis Hizmetleri",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Kombi Servisi",
            "description": "Kombi bakım, onarım ve montaj hizmeti. Vaillant, Baymak, Demirdöküm ve tüm markalar."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Beyaz Eşya Servisi",
            "description": "Buzdolabı, çamaşır makinesi, bulaşık makinesi tamiri. Tüm markalara servis."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Klima Servisi",
            "description": "Klima montajı, bakımı ve tamiri. Daikin, Mitsubishi, Samsung ve tüm markalar."
          }
        }
      ]
    }
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(serviceSchema)}
      </script>
    </>
  );
};

export default StructuredData;
